import { render, staticRenderFns } from "./CreditDetail.vue?vue&type=template&id=68ec0df6&scoped=true"
import script from "./CreditDetail.vue?vue&type=script&lang=js"
export * from "./CreditDetail.vue?vue&type=script&lang=js"
import style0 from "./CreditDetail.vue?vue&type=style&index=0&id=68ec0df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec0df6",
  null
  
)

export default component.exports